import { useWatch } from 'react-hook-form';
import { useGetOne, usePermissions, useRecordContext } from 'react-admin';

export const useContractor = ({ onSuccess } = {}) => {
    const record = useRecordContext();
    const { permissions } = usePermissions();
    const isAdmin = permissions?.isAdmin;
    const formContractorId = useWatch({ name: 'contractorId' });
    const { data, isLoading } = useGetOne('contractor', { id: formContractorId }, { enabled: !!formContractorId && isAdmin, onSuccess });

    if (isAdmin) {
        return { contractorId: formContractorId, contractor: data, isLoading: isLoading };
    }

    if (record?.contractor && onSuccess) {
        onSuccess(record.contractor);
    }

    return { contractorId: record?.contractorId, contractor: record?.contractor, isLoading: false };
};
